import styled from '@emotion/styled'
import { metrics, ThemeMargins } from '../../../__styling/settings/metrics'
import { breakpoint, calcRem } from '../../../__styling/style-functions'
import { tokens } from '@news-mono/design-tokens'

export interface GridProps {
    verticalSpacing?: keyof ThemeMargins | undefined
    verticalGutters?: [keyof ThemeMargins, keyof ThemeMargins]
}

export const StyledFiveCardCollection = styled('div')<GridProps>(
    ({ theme, verticalSpacing, verticalGutters }) => [
        {
            margin: '0 auto',
            width: '100%',
            borderBottom: `${calcRem(1)} solid ${
                tokens.sevennews.colors.palette.articlesV2.horizontalLine
            }`,
            display: 'grid',
            gridRowGap: calcRem(16),
            gridTemplateColumns: '1fr',
            gridTemplateAreas: `
            "one"
            "two"
            "three"
            "four"
            "five"
            `,
            [breakpoint('sm')]: {
                gridColumnGap: calcRem(18),
                gridRowGap: calcRem(8),
                gridTemplateColumns: '1fr 1fr',
                gridTemplateRows: '1fr 1fr 1fr',
                gridTemplateAreas: `
                "one one"
                "two two"
                "three three"
                "h-line h-line"
                "four five"
                `,
            },
            [breakpoint('md')]: {
                paddingBottom: 0,
                gridColumnGap: calcRem(20),
                gridRowGap: calcRem(16),
                '& :nth-child(n+4)': {
                    paddingTop: calcRem(16),
                    paddingBottom: calcRem(16),
                },
                '& :nth-of-type(n+3):nth-of-type(-n+4)': {
                    '&': {
                        position: 'relative',
                        '&::after': {
                            content: `''`,
                            position: 'absolute',
                            height: '50%',
                            width: calcRem(1),
                            background:
                                tokens.sevennews.colors.palette.articlesV2
                                    .horizontalLine,
                            top: '25%',
                            right: calcRem(-13),
                        },
                    },
                },

                gridTemplateColumns: '2fr 1fr 1fr 2fr',
                gridTemplateRows: `1fr 1px`,
                gridTemplateAreas: `
                "one one two two"
                "h-line h-line h-line h-line"
                "three four four five"
                `,
            },
            [breakpoint('lg')]: {
                gridColumnGap: calcRem(52),
                '& :nth-of-type(n+3):nth-of-type(-n+4)': {
                    '&': {
                        '&::after': {
                            right: calcRem(-28),
                        },
                    },
                },
            },

            marginBottom:
                verticalSpacing &&
                calcRem(metrics[theme.kind].margins[verticalSpacing]),
            marginTop:
                verticalSpacing &&
                calcRem(metrics[theme.kind].margins[verticalSpacing]),
            paddingTop:
                verticalGutters &&
                calcRem(metrics.sevennews.margins[verticalGutters[0]]),
            paddingBottom:
                verticalGutters &&
                calcRem(metrics.sevennews.margins[verticalGutters[1]]),
        },
    ],
)

export const StyledHorizontalLine = styled('hr')(() => [
    {
        display: 'none',
        gridArea: 'h-line',
        border: 0,
        width: '100%',
        height: '1px',
        background: tokens.sevennews.colors.palette.articlesV2.horizontalLine,
        [breakpoint('sm')]: {
            display: 'block',
        },
    },
])
